import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { I18nProvider } from './lib/i18n';
import { CartProvider } from './lib/cart';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { SupportButton } from './components/layout/SupportButton';
import { Landing } from './pages/Landing';
import { Verify } from './pages/Verify';
import { Select } from './pages/Select';
import { Checkout } from './pages/Checkout';
import { Payment } from './pages/Payment';
import { Success } from './pages/Success';
import { About } from './pages/About';
import { Journey } from './pages/Journey';
import { TeamMember } from './pages/TeamMember';
import { Contact } from './pages/Contact';
import { Privacy, Terms } from './pages/Legal';
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0" data-mp="23ut9lxqjzq85">
      <Routes location={location} key={location.pathname} data-id="element-1" data-mp="3ijxo6nd1puib">
        <Route path="/" element={<Landing data-id="element-3" data-mp="3ii4su47vuwpm" />} data-id="element-2" data-mp="3ijfu9xduvsdk" />
        <Route path="/verify/:machineId" element={<Verify data-id="element-5" data-mp="3mk84otygs3bf" />} data-id="element-4" data-mp="3mlayb9n68jv1" />
        <Route path="/select/:machineId" element={<Select data-id="element-7" data-mp="3rbra6pbcfxfa" />} data-id="element-6" data-mp="3mjg9vlcoy9m7" />
        <Route path="/checkout/:machineId" element={<Checkout data-id="element-9" data-mp="3recc1ebn6dd1" />} data-id="element-8" data-mp="3rdaselgk8ijp" />
        <Route path="/payment/:machineId" element={<Payment data-id="element-11" data-mp="4n725ibkvc5" />} data-id="element-10" data-mp="5or2zhbcs60" />
        <Route path="/success/:transactionId" element={<Success data-id="element-13" data-mp="2zlli5ahfl0qy" />} data-id="element-12" data-mp="82ld64660ci" />
        <Route path="/about" element={<About data-id="element-15" data-mp="2zn6aquk6q9m6" />} data-id="element-14" data-mp="2zmeowbge3q93" />
        <Route path="/journey" element={<Journey data-id="element-17" data-mp="33lx02fiesmyq" />} data-id="element-16" data-mp="33mow1rfx4mpj" />
        <Route path="/team/:memberId" element={<TeamMember data-id="element-19" data-mp="33oi0d0326uud" />} data-id="element-18" data-mp="33n6zp94wu37h" />
        <Route path="/contact" element={<Contact data-id="element-21" data-mp="38l017ov9q91f" />} data-id="element-20" data-mp="38l8h7pmotugu" />
        <Route path="/privacy" element={<Privacy data-id="element-23" data-mp="3dkl58dpap7l0" />} data-id="element-22" data-mp="38nunzn1r85y0" />
        <Route path="/terms" element={<Terms data-id="element-25" data-mp="3dmfn1j59sjkv" />} data-id="element-24" data-mp="3dl4jnkfqldua" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-27" data-mp="nvstx4mognvy" />} data-id="element-26" data-mp="3dii3iwes5q0g" />
      </Routes>
    </AnimatePresence>;
}
export function App() {
  return <I18nProvider data-id="element-28" data-mp="stuejtzr4v9j">
      <CartProvider data-id="element-29" data-mp="stc864jdl0nw">
        <BrowserRouter data-id="element-30" data-mp="sssrss9dikbz">
          <div className="app-bg flex min-h-screen w-full flex-col" data-id="element-31" data-mp="36hwf6uoms18">
            <Header data-id="element-32" data-mp="34nb3rfi0xwm" />
            <div className="flex-1" data-id="element-33" data-mp="38b7cycbvyf1">
              <AnimatedRoutes data-id="element-34" data-mp="3udkmfuysas9v" />
            </div>
            <Footer data-id="element-35" data-mp="3uevpttobhy0g" />
            <SupportButton data-id="element-36" data-mp="d4nuteha5g1c" />
          </div>
        </BrowserRouter>
      </CartProvider>
    </I18nProvider>;
}